export default __webpack_public_path__ + "static/media/NoData.3334a8e1.svg";